import * as React from 'react'
import { Slot } from 'radix-ui'

import { cn } from '@/lib/utils'
import styles from './Badge.module.scss'

export type BadgeVariant = 'default' | 'secondary' | 'warning' | 'destructive' | 'outline' | 'ghost' | 'link'

function badgeVariants({
  variant = 'default',
  className,
}: {
  variant?: BadgeVariant
  className?: string
} = {}) {
  return cn(styles.badge, styles[variant], className)
}

function Badge({
  className,
  variant = 'default',
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & { variant?: BadgeVariant; asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : 'span'

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={badgeVariants({ variant, className })}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
